import axios from "axios";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

// axios.defaults.baseURL = "http://localhost:8090/cgm_form_api"
// axios.defaults.baseURL = "http://8.210.114.49:8090/cgm_form_api"
axios.defaults.baseURL = "https://doctor.cgmgroup.jp/cgm_form_api_web"
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.axios = axios;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
